import React from "react";
import { Calendar } from "lucide-react";
import moment from "moment";

interface ListCardProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  badge?: string;
  date?: string;
  time?: string;
  onClick?: () => void;
  rightAction?: React.ReactNode;
}

const ListCard: React.FC<ListCardProps> = ({
  icon,
  title,
  subtitle,
  badge,
  date,
  time,
  onClick,
  rightAction,
}) => {
  return (
    <div
      className="flex flex-col items-start gap-2 bg-white p-4 rounded-lg shadow-sm"
      style={{ borderColor: "var(--card-border)" }}
      onClick={onClick}
    >
      <div className="flex items-center justify-between w-full gap-2">
        <div className="flex items-center gap-4 flex-1">
          <div className="p-3 bg-gray-100 rounded-md flex items-center justify-center flex-shrink-0">
            {icon}
          </div>
          <div className="flex-1 space-y-2">
            <p className="text-sm font-medium line-clamp-2">{title}</p>
            {badge && (
              <span className="text-xs bg-gray-100 px-2 py-1 rounded-md text-gray-500">
                {badge}
              </span>
            )}
          </div>
        </div>
        {rightAction && <div className="flex-shrink-0">{rightAction}</div>}
      </div>
      {(date || time || subtitle) && (
        <div className="flex items-center justify-between w-full gap-2">
          {(date || time) && (
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 text-gray-500" />
              <span className="text-xs text-gray-500">
                {date && time ? `${date} • ${time}` : date || time}
              </span>
            </div>
          )}
          {subtitle && !date && !time && (
            <span className="text-xs text-gray-500">{subtitle}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ListCard;
